
const checkFieldValidity = (args) => {
  const collapseQuery = document.querySelectorAll("#application-form .collapse");
  const invalidHeaderCheckQuery = document.querySelectorAll("#application-form .invalid-header-check");

  invalidHeaderCheckQuery.forEach(invalidHeaderCheckEl => {
    invalidHeaderCheckEl.remove();
  });

  let totalInvalidInputs = 0;
  collapseQuery.forEach(collapseEl => {
    const inputQuery = collapseEl.querySelectorAll("input");
    let invalidInputs = 0;
    inputQuery.forEach(input => {
      if (input.checkValidity() === false) {
        invalidInputs++;
        totalInvalidInputs++;
      }

      if (args.firstRun) {
        input.addEventListener("change", () => {
          checkFieldValidity({firstRun: false});
        });
      }
    });

    const collapseHeader = collapseEl.parentElement.querySelector(".accordion-header button");

    // if the collapseHeader contains the text "Credit or Debit Card" then assume it's invalid
    if (collapseHeader && collapseHeader.textContent.includes("Credit or Debit Card") && args.firstRun === true) {
      invalidInputs++;
      totalInvalidInputs++;
    }

    if (collapseHeader && invalidInputs > 0) {
      const invalidDiv = document.createElement("div");
      invalidDiv.classList.add("invalid-header-check", "ms-3", "d-inline", "text-danger", "fw-normal");
      invalidDiv.textContent = `${invalidInputs} Invalid or Required Fields`;
      collapseHeader.appendChild(invalidDiv);
    }

    const totalInvalidInputsEl = document.querySelector("#total-invalid-inputs");
    totalInvalidInputsEl.textContent = `${totalInvalidInputs} Invalid or Required Fields in the sections above.`;
  });
};

checkFieldValidity({firstRun: true});
function addHiddenInput(el, name, value) {
  let input = document.createElement('input')
  input.name = name
  input.value = value
  input.type = 'hidden'
  el.closest('form').appendChild(input)
}

Object.assign(window, {addHiddenInput})
